import GameBill from './GameBill.jsx';

export default GameBill;